module.exports = __webpack_public_path__ + "static/media/cyber.529ea14c.jpg";